import { Component, computed, input } from "@angular/core";
import { IBusinessManager } from "../../components/key-info-physical-exposure/key-info-physical-exposure.component";
import { KeyValuePair, KeyValuePairListComponent } from "../../components/key-value-pair-list/key-value-pair-list.component";

@Component({
    selector: "business-manager",
    templateUrl: "./business-manager.component.html",
    styleUrl: "./business-manager.component.scss",
    imports: [KeyValuePairListComponent],
})
export class BusinessManagerComponent {
    data = input<IBusinessManager>(null);

    keyValuePairs = computed((): KeyValuePair[] => {
        const data = this.data();
        if (!data) return [];
        return [
            { key: "Navn", value: data.name },
            { key: "Org.nr.", value: data.organizationNumber },
            { key: "E-post", value: data.emailAddress },
            { key: "Telefon", value: data.phoneNumber },
            { key: "Regnskapsår", value: data.lastAccountingYear?.toString() },
        ];
    });
}
